import React from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import Container from "@mui/material/Container";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import CssBaseline from "@mui/material/CssBaseline";
import FormControl from "@mui/material/FormControl";
import SaveIcon from "@mui/icons-material/Save";
import * as companyApi from "../../api/companyApi";
import * as countryApi from "../../api/countryApi";
import swal from "sweetalert";
import { withRouter } from "../common/WithRouter";


class NewCompany extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      company: {},
      companyTypes: [],
      countries: [],
      codeTFF: "",
      errors: {},
    };
  }

  async componentDidMount() {
    try {
      this.getcompanyTypes();
      this.getcountries();
    } catch (error) {
      console.log("Error in componentDidMount", error);
    }
  }

  getcompanyTypes = async () => {
    const companyTypes = await companyApi.getCompanyTypes();
    if (companyTypes) {
      this.setState({ companyTypes });
    }
  };

  getcountries = async () => {
    const countries = await countryApi.getCountries();
    if (countries) {
      countries.sort((a, b) => (a.countryName < b.countryName ? -1 : 1));
      this.setState({ countries });
    }
  };

  onChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    const errors = { ...this.state.errors };
    errors[name] = "";
    this.setState({ errors });

    if (e.target.id === "codeTFF") {
      this.setState({ codeTFF: e.target.value });
    } else {
      const company = { ...this.state.company };
      company[name] = value;
      this.setState({ company });
    }
  };

  onSave = async (event) => {
    event.preventDefault();
    if (!this.formIsValid()) return;
    try {
      const { company } = this.state;
      const result = await companyApi.saveCompany(company, true);
      if (result.success) {
        const savedCompany = result.data;

        await swal({
          title: "Bedrift lagret",
          text: "Klikk OK for å gå til bedriftssiden.",
          icon: "success",
        });

        this.props.navigate(`/companydetail/${savedCompany.companyId}`);

      }
    } catch (error) {
      console.log("Error in saving company", error);
      swal({
        title: "Noe gikk galt",
        text: "Kunne ikke lagre bedriften.",
        icon: "error",
      });
    }
  };

  formIsValid = () => {
    const { company } = this.state;
    const errors = {};
    if (!company.companyTypeId) errors.companyTypeId = "Bedriftstype er påkrevd";
    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  render() {
    const layout = { width: "100%", paddingTop: 80 };
    const paper = { paddingLeft: 30, paddingTop: 20 };
    const gridPaddingTop = { paddingTop: 20 };

    return (
      <Container maxWidth="lg">
        <form>
          <main style={layout}>
            <Paper style={paper}>
              <React.Fragment>
                <CssBaseline />
                <h2>Ny Bedrift</h2>
                <Grid container spacing={8}>
                  {/* Left Column */}
                  <Grid item lg={5}>
                    <Grid>
                      <TextField
                        name="companyName"
                        label="Bedriftsnavn"
                        value={this.state.company.companyName || ""}
                        onChange={this.onChange}
                        fullWidth
                        variant="standard"
                        required
                      />
                    </Grid>

                    <Grid style={gridPaddingTop}>
                      <FormControl required fullWidth variant="standard">
                        <InputLabel>Bedriftstype</InputLabel>
                        <Select
                          name="companyTypeId"
                          value={this.state.company.companyTypeId || ""}
                          onChange={this.onChange}
                          error={!!this.state.errors.companyTypeId}
                        >
                          {this.state.companyTypes.map((type, index) => (
                            <MenuItem key={index} value={type.companyTypeId}>
                              {type.companyTypeName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid style={gridPaddingTop}>
                      <TextField
                        name="orgnr"
                        label="Organisasjonsnummer"
                        value={this.state.company.orgnr || ""}
                        onChange={this.onChange}
                        fullWidth
                        variant="standard"
                      />
                    </Grid>

                    <Grid style={gridPaddingTop}>
                      <TextField
                        name="postAddress"
                        label="Postadresse"
                        value={this.state.company.postAddress || ""}
                        onChange={this.onChange}
                        fullWidth
                        variant="standard"
                      />
                    </Grid>

                    <Grid container style={gridPaddingTop} spacing={4}>
                      <Grid item lg={6}>
                        <TextField
                          name="zipCode"
                          label="Postnummer"
                          value={this.state.company.zipCode || ""}
                          onChange={this.onChange}
                          fullWidth
                          variant="standard"
                        />
                      </Grid>
                      <Grid item lg={6}>
                        <TextField
                          name="postal"
                          label="Sted"
                          value={this.state.company.postal || ""}
                          onChange={this.onChange}
                          fullWidth
                          variant="standard"
                        />
                      </Grid>
                    </Grid>

                    <Grid style={gridPaddingTop}>
                      <TextField
                        name="visitingAddress"
                        label="Besøksadresse"
                        value={this.state.company.visitingAddress || ""}
                        onChange={this.onChange}
                        fullWidth
                        variant="standard"
                      />
                    </Grid>

                    <Grid style={gridPaddingTop}>
                      <FormControl fullWidth variant="standard">
                        <InputLabel>Land</InputLabel>
                        <Select name="countryId" value={this.state.company.countryId || ""} onChange={this.onChange}>
                          {this.state.countries.map((country, index) => (
                            <MenuItem key={index} value={country.countryId}>
                              {country.countryName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid style={gridPaddingTop}>
                      <TextField
                        name="phonenumber"
                        label="Telefon"
                        value={this.state.company.phonenumber || ""}
                        onChange={this.onChange}
                        fullWidth
                        variant="standard"
                      />
                    </Grid>

                    <Grid style={gridPaddingTop}>
                      <TextField
                        name="emailCompany"
                        label="E-post"
                        type="email"
                        value={this.state.company.emailCompany || ""}
                        onChange={this.onChange}
                        fullWidth
                        variant="standard"
                      />
                    </Grid>

                    <Grid style={gridPaddingTop}>
                      <TextField
                        name="webpage"
                        label="Nettside"
                        value={this.state.company.webpage || ""}
                        onChange={this.onChange}
                        fullWidth
                        variant="standard"
                      />
                    </Grid>

                    <Grid style={gridPaddingTop}>
                      <Button
                        startIcon={<SaveIcon />}
                        variant="contained"
                        color="primary"
                        onClick={this.onSave}
                        style={{ marginBottom: '16px' }}
                      >
                        Lagre
                      </Button>
                    </Grid>
                  </Grid>

                  {/* Right Column */}
                  <Grid item lg={5}>
                    <h4>TFF</h4>
                    <Grid>
                      <TextField
                        name="emailCaseTFF"
                        label="E-post (skade TFF):"
                        type="email"
                        value={this.state.company.emailCaseTFF || ""}
                        onChange={this.onChange}
                        fullWidth
                        variant="standard"
                      />
                    </Grid>

                    <Grid style={gridPaddingTop}>
                      <TextField
                        name="emailEconomyTFF"
                        label="E-post (økonomi TFF):"
                        type="email"
                        value={this.state.company.emailEconomyTFF || ""}
                        onChange={this.onChange}
                        fullWidth
                        variant="standard"
                      />
                    </Grid>

                    <h4 style={gridPaddingTop}>YFF</h4>
                    <Grid>
                      <TextField
                        name="emailCaseYFF"
                        label="E-post (skade YFF):"
                        type="email"
                        value={this.state.company.emailCaseYFF || ""}
                        onChange={this.onChange}
                        fullWidth
                        variant="standard"
                      />
                    </Grid>
                    <Grid>
                      <TextField
                        name="emailEconomiYFF"
                        label="E-post (økonomi YFF):"
                        type="email"
                        value={this.state.company.emailEconomiYFF || ""}
                        onChange={this.onChange}
                        fullWidth
                        variant="standard"
                      />
                    </Grid>
                    <Grid>
                      <TextField
                        name="emailNavContactYFF"
                        label="E-post (NAV-kontakt YFF):"
                        type="email"
                        value={this.state.company.emailNavContactYFF || ""}
                        onChange={this.onChange}
                        fullWidth
                        variant="standard"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </React.Fragment>
            </Paper>
          </main>
        </form>
      </Container>
    );
  }
}

export default withRouter(NewCompany);